import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';

import './editor.scss';

export default function Edit() {
	return (
		<div { ...useBlockProps() }>
			{ __( 'Your coupon form from voucherify will show up here', 'voucherify' ) }
		</div>
	);
}
